<template>
    <div>
        <!-- 聊天 -->
        <!-- <div>{{source}}</div>
        <div>{{index}}</div> -->
        <div >
            <ul>
                <li>
                    <div class="chat-head"><img :src="source.avatar" alt=""></div>
                    <div class="chat-main-list">
                        <div class="chat-name">
                            <div>{{source.userName}}</div>
                            <div class='chat-time'>{{timeRegular(source.timer)}}</div>
                        </div>
                        <div class="chat-content-box">
                            <div class="chat-cont-1" v-if="source.type == 'text'">
                                <p>{{source.content}}</p>
                            </div>
                            <div class="chat-cont-1" v-if="source.type == 'img'">   
                                <!-- http://file.leancloud.youinsh.com/uKXrykF5cFEVymHBUiclSu8qRhiPuJ4b/avatar.jpg -->
                                <img :src='"http:"+source.content' alt="">
                            </div>
                            <div class="chat-content-quote" v-if="source.referenceInfo">
                                <p v-if="source.referenceInfo.type == 'text'">{{source.referenceInfo.content}}</p>
                                <img v-if="source.referenceInfo.type == 'img'" :src="source.content" alt="">
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data (){
        return {

        }
    },
    methods:{
        timeRegular(data){
            let timerdata = this.$utils.getDate(data)
            return timerdata.n +'-'+ timerdata.y +'-'+ timerdata.r +' '+ timerdata.h +':'+ timerdata.f 
        }
    },
    props:{
        index:{// 每一行的索引
            type:Number
        },
        source:{//source就是items中的每一条数据，items是从接口接到的数据（这里items是一个数组，数组中的每个元素是一个对象，每个对象有id、title两个属性）
            type:Object,
            default:() =>{
                console.log(this.source)
            }
        }
    }
}
</script>
<style scoped lang="scss">
    li{
        display:flex;
        padding:.1rem;
        .chat-head{
            margin-right:.1rem;
            max-width:20%;
            min-width: .36rem;
        }
        .chat-head img{
            width:.36rem;
            height:.36rem;
            border-radius:50%;
        }
        .chat-name{
            display:flex;
            margin-bottom:.1rem;
            justify-content: space-between;
            color:#7f7f7f;
            font-size:.12rem;
        }
        .chat-main-list{
            flex-grow: 1;
        }
        .chat-cont-1 p{
            background:#FFFFFF;
            padding:.08rem;
            font-size:.14rem;
            display:inline-block;
            border-radius: .04rem;
            color:#303133;
        }
    }
    .pclass{
        li{
            .chat-cont-1 p{
                background:#3B3E47;
                padding:.08rem;
                font-size:.14rem;
                display:inline-block;
                border-radius: .04rem;
                color:#ffffff;
            }
            .chat-name{
                color:rgba(255,255,255,.6)
            }
            .chat-time{
                color:rgba(255,255,255,.2);
                font-size:.12rem;
                transform:scale(.9);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/chat/virtualChat.vue